module.exports = __webpack_public_path__ + "static/media/close_icon2.1fd4c6d0.png";